import { mapState } from 'vuex';

export default {
    name: 'linepreloader',
    props: {
    },
}